import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { ServiceSeries } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RailMLParserGateway {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'railml-parser';

  getServiceFromRailML(railML: string) {
    return this.http.post<ServiceSeries[]>(
      `${this.config.host}/${this.path}`,
      railML,
      {
        headers: {
          'Content-Type': 'application/xml',
        },
      },
    );
  }
}
